import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import ServerApp from "./ServerApp";
import { renderToString } from "react-dom/server";
import StandardErrorBoundary from "./errorComponents/StandardErrorBoundary";
import "../src/styles/Commonstyles.scss";
//import StyleContext from 'isomorphic-style-loader/StyleContext';
// import "../src/styles/style.css"

if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof document.createElement === 'function') {
    var preloadState = window.__PRELOADED_STATE__
    ReactDOM.hydrate(
        <StandardErrorBoundary>
            <App skin={preloadState && preloadState.fetch && preloadState.fetch.response && preloadState.fetch.response.skin ? preloadState.fetch.response.skin : "cbSkin"} />
        </StandardErrorBoundary>
        , document.getElementById('root'));
}
else {
    global.renderSSR = (jsonContent) => {
        var jsonContentObj = JSON.parse(jsonContent)
        return renderToString(
            <StandardErrorBoundary>
                <ServerApp skin={jsonContentObj && jsonContentObj.fetch && jsonContentObj.fetch.response && jsonContentObj.fetch.response.skin ? jsonContentObj.fetch.response.skin : "cbSkin"} jsonContent={jsonContentObj} />
            </StandardErrorBoundary>
        )
    };
}
